const { Box, Image, Heading, Text, Stack } = require("@chakra-ui/react");

export const Categorylaunch = () => {
  return (
    <Box textAlign={"center"} bgColor={"white"}>
      <Heading>New Category Launches</Heading>
      <Stack
        display={"flex"}
        flexDirection={"row"}
        w={"70%"}
        m={"auto"}
        p={"20px"}
        gap={"10px"}
        alignItems={"center"}
        mt={"50px"}
      >
        <Box>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/luminosity/1646140576865-02aba1.jpeg"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />
          <Text>Expert Counselling</Text>
          <Text fontWeight={"light"} as={"small"}>
            Advanced Skin Treatments
          </Text>
        </Box>
        <Box>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/bigpictures/carpenter.jpg"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />
          <Text>Furniture Making, Upholstery & Polish</Text>
        </Box>
        <Box>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1635829954373-d05590.jpeg"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />

          <Text>Air Purifier</Text>
          <Text as={"small"} fontWeight={"light"}>
            Flat ₹100 off
          </Text>
        </Box>
        <Box>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/supply/customer-app-supply/1643120136395-80523e.jpeg"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />
          <Text>RO Water Purifier</Text>
        </Box>
      </Stack>
    </Box>
  );
};
